// Utilitaire pour gérer les erreurs Auth0 de manière robuste

export const handleAuth0Error = (error) => {
  console.error('Erreur Auth0:', error);
  
  // Gestion spécifique selon le type d'erreur
  switch (error.error) {
    case 'access_denied':
      console.log('Accès refusé par l\'utilisateur');
      return { 
        type: 'access_denied', 
        message: 'Connexion annulée par l\'utilisateur',
        action: 'redirect_to_login'
      };
    
    case 'login_required':
      console.log('Login requis');
      return { 
        type: 'login_required', 
        message: 'Veuillez vous connecter',
        action: 'redirect_to_login'
      };
    
    case 'consent_required':
      console.log('Consentement requis');
      return { 
        type: 'consent_required', 
        message: 'Consentement requis pour continuer',
        action: 'redirect_to_login'
      };
    
    case 'invalid_request':
      console.log('Requête invalide');
      return { 
        type: 'invalid_request', 
        message: 'Erreur de configuration Auth0',
        action: 'show_error'
      };
    
    default:
      console.log('Erreur Auth0 non gérée:', error);
      return { 
        type: 'unknown', 
        message: 'Une erreur inattendue s\'est produite',
        action: 'show_error'
      };
  }
};

// Fonction pour créer une URL Auth0 manuelle en cas d'échec
export const createAuth0Url = (domain, clientId, redirectUri) => {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid profile email',
    response_mode: 'query'
  });
  
  return `https://${domain}/authorize?${params.toString()}`;
};

// Fonction pour gérer la redirection de manière sécurisée
export const safeRedirect = (url) => {
  try {
    // Vérifier que l'URL est valide
    new URL(url);
    window.location.href = url;
  } catch (error) {
    console.error('URL invalide:', url);
    // Fallback vers la page d'accueil
    window.location.href = '/';
  }
};
